module.exports = __webpack_public_path__ + "static/media/photo1@2x.4e7b9f50.jpg";